import Marionette from "../../shared/marionette-mustache";
import { ExactResultModel } from "../../search/models/exact-result";
import { backboneViewProperties } from "../../decorators/backbone-properties";

require("../styles/exact-result.less");
const caseResultTemplate = require<string>("./exact-case-result.html");
const statuteResultTemplate = require<string>("./exact-statute-result.html");
const statuteOutlineTemplate = require<string>("../../desktop/views/statute-outline.html");
const statuteSectionResultTemplate = require<string>("./exact-statute-section-result.html");
const siResultTemplate = require<string>("./exact-si-result.html");
const euResultTemplate = require<string>("./exact-eu-result.html");

const dom = {
    SUMMARY: ".result-summary",
    SUMMARY_SHOW_MORE: ".summary-show-more",
    PROCESSING_STATUS_CONTAINER: ".document-processing-status"
};

@backboneViewProperties({
    tagName: "div",
    className: "js-category-option"
})
export class ExactResultView extends Marionette.ItemView<ExactResultModel> {
    public template: string;

    constructor(options?: Backbone.ViewOptions<ExactResultModel>) {
        super(options);
        this.setTemplate(options);
    }

    public render(): ExactResultView {
        this.$el.hide();
        super.render.call(this);
        this.setupDocumentProcessingStatusPopover();
        this.$el.fadeIn(100);
        return this;
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        return events;
    }

    public fullTextChanged(model, prop) {
        this.$el.toggleClass("full-text", prop);
    }

    public truncatedSummaryChanged(): void {
        this.$(dom.SUMMARY).text(this.model.Summary);
    }

    private setTemplate(options: Backbone.ViewOptions<ExactResultModel>) {
        switch (options.model.DocTypeString) {
            case "CASE":
                this.template = caseResultTemplate;
                break;
            case "STATUTE":
                this.template = statuteOutlineTemplate;
                break;
            case "SI":
                this.template = siResultTemplate;
                break;
            case "STATUTE_SECTION":
                this.template = statuteSectionResultTemplate;
                break;
            case "EU_SECTOR0":
            case "EU_SECTOR1":
            case "EU_SECTOR2":
            case "EU_SECTOR3":
            case "EU_SECTOR4":
            case "EU_SECTOR5":
            case "EU_SECTOR6":
            case "EU_SECTOR7":
            case "EU_SECTOR8":
            case "EU_SECTOR9":
                this.template = euResultTemplate;
                break;
            default:
                break;
        }
    }

    private setupDocumentProcessingStatusPopover() {
            const $objProcessing = this.$(dom.PROCESSING_STATUS_CONTAINER);
            let hdr = "Processing status: ";
            if (this.model.get("FailedProcessing")) {
                hdr += "Failed";
                $objProcessing.removeClass("processing-completed").addClass("processing-failed");
            } else {
                hdr += "Completed";
                $objProcessing.removeClass("processing-failed").addClass("processing-completed");
            }
            const html = `See the latest <a href='processing/batch/${this.model.get("LastBatchId")}/${this.model.get("EntityId")}'>process log</a>`;
            $objProcessing.attr("title", hdr);
            $objProcessing.attr("data-content", html);
            $objProcessing.popover({
                placement: "left",
                html: true,
                trigger: "manual"
            }).click((e) => {
                this.$(dom.PROCESSING_STATUS_CONTAINER).popover("show");
                return false;
            });
        }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/exact-result.ts